module.exports = __webpack_public_path__ + "img/public/AdminIcons/reviewsManagement.svg?775eb4b8";